import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="checklists" pageTitle="Checklists" pageDescription="Checklists prácticos de cumplimiento para proyectos regulatorios, de calidad y de validación en pharma, biotech, Medical Devices e IVD." showAssessments />;

export const Route = createFileRoute("/es/downloads/checklists/")({
  head: () => buildRouteHead("/es/downloads/checklists", {
    title: "Checklists de cumplimiento en Life Sciences | QbD Group",
    description: "Descarga checklists prácticos sobre MDR, ISO 13485, 21 CFR Part 11, Annex 11 y más, elaborados por los expertos de QbD Group.",
  }),
  component: ContentListingRoute,
});
